import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import type { ScheduleBoardSettingsFormToModel } from 'ab-requestModels/scheduleBoard.requestModel';

import * as TimeOptionUtils from '@acceligentllc/shared/utils/timeOption';

import type { ColorPalette } from '@acceligentllc/shared/enums/color';
import type { DisplayViewToggle } from '@acceligentllc/shared/enums/displayViewToggle';

export class ScheduleBoardSettingsRequestForm {
	displayViewChangeTime: string;
	displayViewRotationTime: number;
	skillColorGrid: ColorPalette[][];
	cdlInSkillsGrid: boolean;
	displayViewType: DisplayViewToggle;
	includeNonWorkingDaysOnDisplayView: boolean;

	constructor(company: CompanyViewModel) {
		this.displayViewChangeTime = TimeOptionUtils.toString(company.displayViewChangeTime);
		this.displayViewRotationTime = company.displayViewRotationTime;
		this.skillColorGrid = company.skillColorGrid;
		this.cdlInSkillsGrid = company.cdlInSkillsGrid;
		this.displayViewType = company.displayViewType;
		this.includeNonWorkingDaysOnDisplayView = company.includeNonWorkingDaysOnDisplayView;
	}

	static toModel(form: ScheduleBoardSettingsRequestForm): ScheduleBoardSettingsFormToModel {
		const displayViewChangeTime = TimeOptionUtils.toNumber(form.displayViewChangeTime);
		if (!displayViewChangeTime) {
			throw new Error('Change time not defined');
		}

		return {
			displayViewChangeTime,
			displayViewRotationTime: form.displayViewRotationTime,
			skillColorGrid: form.skillColorGrid,
			cdlInSkillsGrid: form.cdlInSkillsGrid,
			includeNonWorkingDaysOnDisplayView: form.includeNonWorkingDaysOnDisplayView,
			displayViewType: form.displayViewType,
		};
	}
}
